.container {
	padding: 8px 20px 3px 20px;

	.titleCard {
		display: flex;
		align-items: center;
		background: linear-gradient(to right, #7bc043, #6aad3d);
		color: #fff;
		padding: 12px 20px;
		border-radius: 8px;
		gap: 12px;

		&.titleWarning {
			background: linear-gradient(to right, #e67e22, #d95f0e);
		}

		.iconContainer {
			display: flex;
			align-items: center;
			justify-content: center;

			.icon {
				width: 20px;
				height: 20px;
				color: white;
			}
		}

		h4 {
			margin: 0;
			font-weight: 700;
			font-size: 16px;
		}

		p {
			margin: 0;
			font-size: 13px;
			font-weight: 400;

			strong {
				font-weight: 700;
			}
		}
	}
}
